import groupBy from 'lodash-es/groupBy';
import mapValues from 'lodash-es/mapValues';
import sortBy from 'lodash-es/sortBy';

import { isNotNil } from '@gn-audio/jss-components';
import { AvailabilityState, FamilyGroup, ProductWithAttributes } from '@gn-audio/jss-core';

import { StandardPriceModel } from 'api/pricesApi/pricesModel';

export const sortGroupsByOrderabilityThenPrice = (
  groups: FamilyGroup[],
  prices: StandardPriceModel[]
): FamilyGroup[] => {
  const validPrices = prices.filter(Boolean);
  return sortBy(groups, (gr) => {
    const price = validPrices.find((p) => p.sku === gr.sku);
    const availability = price?.availabilityState ?? AvailabilityState.ComingSoon;
    if (availability >= AvailabilityState.WhereToBuy) return Infinity;
    return price?.discountedPrice ?? price?.listedPrice ?? Infinity;
  });
};

export const Meta3dEngravingRenderingUuidAttribute = 'Meta_3dEngravingRenderingUuid';
export const ProductPortfolioAttribute = 'Product_Portfolio';
export const MetaProducttypeAttribute = 'Meta_Producttype';
export const ProductEngravingAttribute = 'Product_Engraving';
export const ProductBrandColorAttribute = 'Product_BrandColorPublicWeb';

//TODO: Move to jss-components
export const getAvailabilityState = (
  price?: StandardPriceModel | null
): AvailabilityState | null => {
  if (price === undefined) {
    return null;
  }

  if (price === null) {
    return AvailabilityState.WhereToBuy;
  }

  const { availabilityState } = price;
  if (typeof availabilityState === 'number' && availabilityState in AvailabilityState) {
    return availabilityState as unknown as AvailabilityState;
  }

  return AvailabilityState.WhereToBuy;
};

export const getGroupAttributesObject = (
  group?: FamilyGroup | ProductWithAttributes
): Record<string, string[]> => {
  if (!group) return {};
  const attributesDictionary = groupBy(group?.attributes, (attr) => attr.key);
  return mapValues(attributesDictionary, (attributes) =>
    attributes.map((attr) => attr.valueKey).filter(isNotNil)
  );
};

export const getAttributeValue = (
  group: FamilyGroup | ProductWithAttributes | undefined,
  attributeName: string
): string | undefined => {
  if (!group) return;
  return group.attributes?.find((attr) => attr.key === attributeName)?.value ?? undefined;
};
